(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1717],{

/***/ 36483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ FinancialAnnouncementPage; }
});

// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/index.tsx + 3 modules
var Ir = __webpack_require__(82319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Mpocket/Accordion.tsx
var Accordion = __webpack_require__(99515);
// EXTERNAL MODULE: ./src/hooks/useMpocketScript.ts
var useMpocketScript = __webpack_require__(98259);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Library/FinancialAnnouncement/index.tsx
// import styled from 'styled-components'
// import { theme } from '@/styles/theme'




 // import { Accordion } from '@/components/layouts/Ir/Accordion'






var FinancialAnnouncementPage = function FinancialAnnouncementPage() {
  (0,useMpocketScript/* useMpocketScript */.k)('//irpocket.com/141A/irpocket/config-utils-main_en.js'); // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main_en.js')

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      enTitleText: "Financial Results Related Materials",
      subTitleText: ""
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
      id: "irp-library-category6",
      className: "irp-library-category irp-library-category-1 irp-library-category-2"
    })]
  });
};

FinancialAnnouncementPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Investor Relations',
    path: '/en/ir'
  }, {
    name: 'IR Library',
    path: '/en/ir/library'
  }, {
    name: 'Financial Results Related Materials',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Financial Statements Related Materials",
      description: "Documents related to financial statements, including the financial results briefing and financial results presentation materials.",
      ogp: {
        url: 'en/ir/library/financial-announcement/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};
/*
const Listarea = styled.div`
display:flex;
  }
`

const Separator = styled.div`{
  margin: 20px 0px;
  border: 1px solid ${theme.colors.backgroundBlue};
  }
`
*/
;// CONCATENATED MODULE: ./src/pages/en/ir/library/financial-announcement.tsx


/***/ }),

/***/ 53987:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/library/financial-announcement",
      function () {
        return __webpack_require__(36483);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,4591,403,9774,2888,179], function() { return __webpack_exec__(53987); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);